export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.044 2.005a1 1 0 00-.608.288L2.293 7.436A1 1 0 002 8.143v7.714a1 1 0 00.293.707l5.143 5.143a1 1 0 00.707.293h7.714a1 1 0 00.707-.293l5.143-5.143a1 1 0 00.293-.707V8.143a1 1 0 00-.293-.707l-5.143-5.143A1 1 0 0015.857 2H8.143l-.1.005zM16 11v2H8v-2h8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};